// @flow
/* eslint-disable import/prefer-default-export */
// $FlowFixMe
import type { UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import { QUERIES } from "@/enums/queries";
import type { CreateCustomerField, CustomerField } from "types/customerField";

import { createCustomerField } from "./services/mutateCustomerFields";
import { invalidateLoadCustomerFields } from "./useLoadCustomerField";

type Props = {
  addCustomerField: (data: CreateCustomerField) => Promise<void>,
  isLoading: boolean,
} & UseMutationResult<CustomerField, Error>;

export const useAddCustomerFields = (options: any = {}): Props => {
  const mutation = useMutation({
    mutationKey: [QUERIES.CUSTOMER_FIELDS.ADD],
    mutationFn: async ({ data }: { data: CreateCustomerField }) => {
      return await createCustomerField(data);
    },
    onSuccess: () => {
      invalidateLoadCustomerFields();
    },
    ...options,
  });

  const addCustomerFieldReq = async (data: CreateCustomerField) => {
    return mutation.mutateAsync({ data });
  };

  return {
    addCustomerField: addCustomerFieldReq,
    ...mutation,
  };
};
